import React, { ComponentType, memo } from 'react';
import { TableContainer } from '@mui/material';
import { TableCardRowProps } from '../Table/types';
import { Table } from '../Table';
import { TableBody, TableBodyIdByProp } from './TableBody';
import { TableHead } from './TableHead';
import { TableSummary, TableSummaryProps } from './TableSummary';

type TableCardPropTypes<T, V extends Record<string, string | number | undefined>> = {
  idBy?: TableBodyIdByProp<T>;
  rowComponent: ComponentType<TableCardRowProps<T>>;
  emptyComponent?: string;
  summary?: TableSummaryProps<V>;
  minHeight?: string;
  striped?: boolean;
  children: T[];
};

const TableCard = <T, V extends Record<string, string | number | undefined>>({
  idBy,
  minHeight = '30rem',
  children,
  rowComponent,
  emptyComponent,
  striped,
  summary,
}: TableCardPropTypes<T, V>) => {
  return (
    <TableContainer sx={{ p: 2, minHeight: minHeight }}>
      <Table striped={striped}>
        <TableHead rowComponent={rowComponent} />
        <TableBody idBy={idBy} rowComponent={rowComponent} emptyComponent={emptyComponent}>
          {children}
        </TableBody>
        {summary && <TableSummary {...summary} />}
      </Table>
    </TableContainer>
  );
};

// workaround React.memo() dropping generic type arguments
// https://github.com/DefinitelyTyped/DefinitelyTyped/issues/37087
const memoizedTableCard = memo(TableCard) as typeof TableCard;
export { memoizedTableCard as TableCard };
